import { forwardRef, memo, Ref } from 'react';
import {
  chakra,
  HTMLChakraProps,
  RecipeProps,
  useRecipe,
} from '@chakra-ui/react';

interface InputElementProps
  extends HTMLChakraProps<'div'>,
    RecipeProps<'inputElement'> {}

const InputElementComponent = (
  { css, ...props }: InputElementProps,
  ref: Ref<HTMLDivElement>,
) => {
  const recipe = useRecipe({ key: 'inputElement' });
  const [variantProps, localProps] = recipe.splitVariantProps(props);
  const styles = recipe(variantProps);
  return <chakra.div ref={ref} {...localProps} css={[styles, css]} />;
};

export const InputElement = memo(
  forwardRef<HTMLDivElement, InputElementProps>(InputElementComponent),
);
